module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/4@2x_35970f16eefe6d3b742966c29e20f12b.png";